// position.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const usePositionStore = defineStore('position', {
    state: () => ({
        allPosition: [],
        positionList: [],
    }),
    actions: {
        async getAllPosition(filter) {
            try {
                const response = await axios.get('/positions', { params: filter })
                if (response.status === 200) {
                    this.allPosition = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getPosition(filter) {
            try {
                const response = await axios.get('/positions', { params: filter })
                if (response.status === 200) {
                    this.positionList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getPositionById(id) {
            try {
                const response = await axios.get(`/position/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createPosition(body) {
            try {
                const response = await axios.post('/position', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updatePosition(body) {
            try {
                const response = await axios.post(`/position/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async positionDeleteCheck(id, filter) {
            try {
                const response = await axios.get(`/position/${id}/deletion-check`, { params: filter, noLoader: true })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deletePosition(id) {
            try {
                const response = await axios.delete(`/position/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
